import { createServerFn } from "@tanstack/react-start";
import { getCookie, getRequestHeader, setCookie } from "@tanstack/react-start/server";
import { z } from "zod";

import { ALL_LOCALES, LOCALE_COOKIE, isActiveLocale, resolveLocale } from "./config";

export const getLocale = createServerFn({ method: "GET" }).handler(() =>
  resolveLocale(getCookie(LOCALE_COOKIE), getRequestHeader("cf-ipcountry") ?? undefined),
);

export const setLocale = createServerFn({ method: "POST" })
  .inputValidator((data) => z.object({ locale: z.enum(ALL_LOCALES) }).parse(data))
  .handler(({ data }) => {
    if (!isActiveLocale(data.locale)) throw new Error("Language not available");
    setCookie(LOCALE_COOKIE, data.locale, {
      path: "/",
      maxAge: 60 * 60 * 24 * 365,
      sameSite: "lax",
      secure: true,
      httpOnly: true,
    });
    return data.locale;
  });
